document.addEventListener("DOMContentLoaded", function () {
  const allItems = document.querySelectorAll(".faq_item");

  allItems.forEach((item) => {
    const questionWrapper = item.querySelector(".faq_question__wrapper");
    const toggleButton = item.querySelector(".question_toggle__open");

    if (!questionWrapper) return;

    questionWrapper.addEventListener("click", function () {

      allItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");

          const otherToggle = otherItem.querySelector(".question_toggle__open");
          if (otherToggle) {
            otherToggle.textContent = "+";
          }
        }
      });

      item.classList.toggle("active");

      if (toggleButton) {
        toggleButton.textContent = item.classList.contains("active") ? "-" : "+";
      }
    });
  });
});